import {
  validateListName,
  validateListPeriod,
} from '../../_shared/domain/list-field-validation';
import { namingFieldMatches } from '../../_shared/domain/naming-convention';
import type { ListDraft } from './list-draft.model';

/** Field-level validation errors, keyed by draft field name. Empty = valid. */
export type ValidationErrors = Partial<Record<keyof ListDraft, string>>;

/**
 * Pure business validation for a list draft. Composes the shared name/period
 * validators with the Add-only rules (a licence, a name in the four parts of the
 * convention, at least one method). No React, no Redux; trivially unit-testable.
 */
export function validateDraft(draft: ListDraft): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!draft.licenceId) errors.licenceId = 'A licence is required.';
  const nameError = validateListName(draft.name);
  if (nameError) errors.name = nameError;
  // The mask writes the name in four parts; a new list fills all four (#595).
  else if (!namingFieldMatches(draft.name).every(Boolean)) {
    errors.name = 'Fill in the four parts of the name.';
  }
  Object.assign(errors, validateListPeriod(draft.startDate, draft.endDate));
  if (draft.methods.length === 0) errors.methods = 'Select at least one method.';

  return errors;
}
